<template>
  <section class="upload-name">
    <header>
      <div class="flow-btn">
        <button @click.prevent="$emit('back')">{{ $t('buttons.back') }}</button>
      </div>
      <div class="title">
        <h1>{{ $t('create.nameTitle') }}:</h1>
        <p>{{ $t('create.nameSubtitle') }}</p>
      </div>
      <div class="flow-btn">
        <button :class="{ 'alt-btn': !nameValue }" @click="nextStep">{{ $t(nextLabel) }}</button>
      </div>
    </header>
    <div class="content">
      <input type="text" v-model="nameValue" :placeholder="$t('create.namePlaceholder')" maxlength="30">
    </div>
  </section>
</template>

<script>
import { SAVE_MEDIA_NAME, SAVE_MEDIA } from '@/store/actions.type'

export default {
  name: 'upload-name',
  data() {
    return {
      nameValue: ''
    }
  },
  computed: {
    nextLabel() {
      return this.nameValue ? 'buttons.continue' : 'buttons.skipForNow'
    }
  },
  methods: {
    nextStep() {
      this.$store.dispatch(SAVE_MEDIA_NAME, this.nameValue)
      this.$store.dispatch(SAVE_MEDIA, false)
      this.$emit('next')
    }
  },
  watch: {
    nameValue() {
      this.dirty = true
    }
  },
  created() {
    this.nameValue = this.$store.state.media.name
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin: auto;
  max-width: 400px;
}
</style>
